import { LANGS } from "../i18n";

export default function LangBar({ lang, onChange }) {
  return (
    <div className="tt-langs">
      {LANGS.map((item) => (
        <button
          key={item.id}
          type="button"
          className={lang === item.id ? "tt-lang on" : "tt-lang"}
          onClick={() => onChange(item.id)}
        >
          {item.label}
        </button>
      ))}
    </div>
  );
}
